import type { ConfigType } from '@plone/registry';

import HeroBlockView from '../components/Blocks/Hero/View';
import HeroBlockEdit from '../components/Blocks/Hero/Edit';
import IntroBlockView from '../components/Blocks/Intro/View';
import IntroBlockEdit from '../components/Blocks/Intro/Edit';
import ChefAboutBlockView from '../components/Blocks/ChefAbout/View';
import ChefAboutBlockEdit from '../components/Blocks/ChefAbout/Edit';
import LunchFeatureBlockView from '../components/Blocks/LunchFeature/View';
import LunchFeatureBlockEdit from '../components/Blocks/LunchFeature/Edit';
import DishShowcaseBlockView from '../components/Blocks/DishShowcase/View';
import DishShowcaseBlockEdit from '../components/Blocks/DishShowcase/Edit';
import HoursBlockView from '../components/Blocks/Hours/View';
import HoursBlockEdit from '../components/Blocks/Hours/Edit';
import PhoneCtaBlockView from '../components/Blocks/PhoneCta/View';
import PhoneCtaBlockEdit from '../components/Blocks/PhoneCta/Edit';
import LocationBlockView from '../components/Blocks/Location/View';
import LocationBlockEdit from '../components/Blocks/Location/Edit';
import ZenchefBlockView from '../components/Blocks/Zenchef/View';
import ZenchefBlockEdit from '../components/Blocks/Zenchef/Edit';
import FeaturedMenuBlockView from '../components/Blocks/FeaturedMenu/View';
import FeaturedMenuBlockEdit from '../components/Blocks/FeaturedMenu/Edit';
import MenuSectionBlockView from '../components/Blocks/MenuSection/View';
import MenuSectionBlockEdit from '../components/Blocks/MenuSection/Edit';
import SetMenuBlockView from '../components/Blocks/SetMenu/View';
import SetMenuBlockEdit from '../components/Blocks/SetMenu/Edit';
import DrinksSectionBlockView from '../components/Blocks/DrinksSection/View';
import DrinksSectionBlockEdit from '../components/Blocks/DrinksSection/Edit';
import MenuTocBlockView from '../components/Blocks/MenuToc/View';
import MenuTocBlockEdit from '../components/Blocks/MenuToc/Edit';
import BackCtaBlockView from '../components/Blocks/BackCta/View';
import BackCtaBlockEdit from '../components/Blocks/BackCta/Edit';
import NoticeBlockView from '../components/Blocks/Notice/View';
import NoticeBlockEdit from '../components/Blocks/Notice/Edit';

import GalleryBlockView from '../components/Blocks/Gallery/View';
import GalleryBlockEdit from '../components/Blocks/Gallery/Edit';
import { getAsyncData as getGalleryAsyncData } from '../components/Blocks/Gallery/folder';
import ParallaxImageBlockView from '../components/Blocks/ParallaxImage/View';
import ParallaxImageBlockEdit from '../components/Blocks/ParallaxImage/Edit';
import PressMentionsBlockView from '../components/Blocks/PressMentions/View';
import PressMentionsBlockEdit from '../components/Blocks/PressMentions/Edit';

import noticeSVG from '../icons/phosphor/notice.svg';
import heroSVG from '../icons/phosphor/hero.svg';
import introSVG from '../icons/phosphor/intro.svg';
import chefAboutSVG from '../icons/phosphor/chef-about.svg';
import lunchFeatureSVG from '../icons/phosphor/lunch-feature.svg';
import dishShowcaseSVG from '../icons/phosphor/dish-showcase.svg';
import hoursSVG from '../icons/phosphor/hours.svg';
import phoneCtaSVG from '../icons/phosphor/phone-cta.svg';
import locationSVG from '../icons/phosphor/location.svg';
import zenchefSVG from '../icons/phosphor/zenchef.svg';
import featuredMenuSVG from '../icons/phosphor/featured-menu.svg';
import menuSectionSVG from '../icons/phosphor/menu-section.svg';
import setMenuSVG from '../icons/phosphor/set-menu.svg';
import drinksSectionSVG from '../icons/phosphor/drinks-section.svg';
import menuTocSVG from '../icons/phosphor/menu-toc.svg';
import backCtaSVG from '../icons/phosphor/back-cta.svg';

import gallerySVG from '../icons/phosphor/gallery.svg';
import parallaxImageSVG from '../icons/phosphor/parallax-image.svg';
import pressMentionsSVG from '../icons/phosphor/press-mentions.svg';

export default function installBlocks(config: ConfigType) {
  config.blocks.groupBlocksOrder.push({
    id: 'editorial',
    title: 'Mise en avant',
  });

  config.blocks.groupBlocksOrder.push({
    id: 'menu',
    title: 'Carte & boissons',
  });

  config.blocks.groupBlocksOrder.push({
    id: 'contact',
    title: 'Contact & horaires',
  });

  config.blocks.groupBlocksOrder.push({
    id: 'media',
    title: 'Médias',
  });

  config.blocks.blocksConfig.noticeBlock = {
    id: 'noticeBlock',
    title: "Bandeau d'annonce",
    icon: noticeSVG,
    group: 'editorial',
    view: NoticeBlockView,
    edit: NoticeBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.heroBlock = {
    id: 'heroBlock',
    title: 'Hero',
    icon: heroSVG,
    group: 'editorial',
    view: HeroBlockView,
    edit: HeroBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.introBlock = {
    id: 'introBlock',
    title: 'Introduction',
    icon: introSVG,
    group: 'editorial',
    view: IntroBlockView,
    edit: IntroBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.chefAboutBlock = {
    id: 'chefAboutBlock',
    title: 'Le chef',
    icon: chefAboutSVG,
    group: 'editorial',
    view: ChefAboutBlockView,
    edit: ChefAboutBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.pressMentionsBlock = {
    id: 'pressMentionsBlock',
    title: 'Presse & distinctions',
    icon: pressMentionsSVG,
    group: 'editorial',
    view: PressMentionsBlockView,
    edit: PressMentionsBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.lunchFeatureBlock = {
    id: 'lunchFeatureBlock',
    title: 'Lunch du moment',
    icon: lunchFeatureSVG,
    group: 'menu',
    view: LunchFeatureBlockView,
    edit: LunchFeatureBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.dishShowcaseBlock = {
    id: 'dishShowcaseBlock',
    title: 'Plats vedettes',
    icon: dishShowcaseSVG,
    group: 'menu',
    view: DishShowcaseBlockView,
    edit: DishShowcaseBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.hoursBlock = {
    id: 'hoursBlock',
    title: 'Horaires',
    icon: hoursSVG,
    group: 'contact',
    view: HoursBlockView,
    edit: HoursBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.phoneCtaBlock = {
    id: 'phoneCtaBlock',
    title: 'CTA Téléphone',
    icon: phoneCtaSVG,
    group: 'contact',
    view: PhoneCtaBlockView,
    edit: PhoneCtaBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.zenchefBlock = {
    id: 'zenchefBlock',
    title: 'Réservation en ligne',
    icon: zenchefSVG,
    group: 'contact',
    view: ZenchefBlockView,
    edit: ZenchefBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.locationBlock = {
    id: 'locationBlock',
    title: 'Nous trouver',
    icon: locationSVG,
    group: 'contact',
    view: LocationBlockView,
    edit: LocationBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.featuredMenuBlock = {
    id: 'featuredMenuBlock',
    title: 'Menu dégustation',
    icon: featuredMenuSVG,
    group: 'menu',
    view: FeaturedMenuBlockView,
    edit: FeaturedMenuBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.menuSectionBlock = {
    id: 'menuSectionBlock',
    title: 'Section carte',
    icon: menuSectionSVG,
    group: 'menu',
    view: MenuSectionBlockView,
    edit: MenuSectionBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.setMenuBlock = {
    id: 'setMenuBlock',
    title: 'Menu à prix fixe',
    icon: setMenuSVG,
    group: 'menu',
    view: SetMenuBlockView,
    edit: SetMenuBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.drinksSectionBlock = {
    id: 'drinksSectionBlock',
    title: 'Section boissons',
    icon: drinksSectionSVG,
    group: 'menu',
    view: DrinksSectionBlockView,
    edit: DrinksSectionBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.menuTocBlock = {
    id: 'menuTocBlock',
    title: 'Sommaire carte',
    icon: menuTocSVG,
    group: 'menu',
    view: MenuTocBlockView,
    edit: MenuTocBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.backCtaBlock = {
    id: 'backCtaBlock',
    title: 'CTA retour',
    icon: backCtaSVG,
    group: 'menu',
    view: BackCtaBlockView,
    edit: BackCtaBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.galleryBlock = {
    id: 'galleryBlock',
    title: 'Galerie',
    icon: gallerySVG,
    group: 'media',
    view: GalleryBlockView,
    edit: GalleryBlockEdit,
    getAsyncData: getGalleryAsyncData,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  config.blocks.blocksConfig.parallaxImageBlock = {
    id: 'parallaxImageBlock',
    title: 'Image parallax',
    icon: parallaxImageSVG,
    group: 'media',
    view: ParallaxImageBlockView,
    edit: ParallaxImageBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  return config;
}
